import stylesGlobal from '../../style';

const styles = {
  eyeIcon: {
    cursor: 'pointer',
    marginLeft: 8,
    width: 20,
    height: 20,
    alignSelf: 'center',
  },
  buttonResend: {
    padding: 0,
    marginLeft: 8,
    background: 'none',
  },
  shareResend: {
    height: 96,
    width: 96,
  },
  buttonUpgrade: {
    borderRadius: 4,
    boxShadow: '0 2px 6px 0 rgba(51, 51, 51, 0.08)',
    background: stylesGlobal.yellow500,
    padding: 6,
    width: 232,
  },
  buttonUpgradeHover: {
    borderRadius: 4,
    boxShadow: '0 2px 6px 0 rgba(51, 51, 51, 0.08)',
    background: stylesGlobal.neutral50,
    padding: 6,
    width: 232,
  },
};

export default styles;
